module.exports = __webpack_public_path__ + "static/img/daiyunying_05.3d56b649.jpg";